module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap",
    attrs: {
      "id": "aaa"
    }
  }, [_c('header', {
    staticClass: "public-head-layout wrapper",
    staticStyle: {
      "width": "1226px",
      "margin": "0px auto"
    }
  }, [_c('div', {
    staticClass: "site-logo index_logo"
  }, [_c('router-link', {
    attrs: {
      "to": "index"
    }
  }, [_c('img', {
    staticClass: "pngFix",
    staticStyle: {
      "width": "68px",
      "height": "68px"
    },
    attrs: {
      "src": require("./../../../static/tyjf.png")
    }
  })])], 1), _vm._v(" "), _c('nav', {
    staticClass: "public-nav-layout"
  }, [_c('ul', {
    staticClass: "site-menu"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "site-menu-li mr54",
      class: _vm.currentNavIndex == index ? 'current-nav' : '',
      on: {
        "mouseenter": function($event) {
          return _vm.mouseEnter(item.id)
        },
        "click": function($event) {
          return _vm.navHandle(index, item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "head-search-bar"
  }, [_c('el-input', {
    staticClass: "input-with-select",
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('el-select', {
    staticClass: "head-search-select",
    attrs: {
      "slot": "prepend",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSearch
    },
    slot: "prepend",
    model: {
      value: (_vm.searchType),
      callback: function($$v) {
        _vm.searchType = $$v
      },
      expression: "searchType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "商品",
      "value": "goods"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "店铺",
      "value": "shop"
    }
  })], 1), _vm._v("\n\n        >\n        "), _c('div', {
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-search",
    staticStyle: {
      "font-size": "24px",
      "margin-left": "20px",
      "color": "#fff"
    },
    on: {
      "click": _vm.searchBtn
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "shop-car",
    on: {
      "click": function($event) {
        return _vm.toCart()
      }
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-cart",
    staticStyle: {
      "font-size": "24px",
      "color": "#EC671A"
    }
  }), _vm._v(" "), _c('span', [_vm._v("购物车")]), _vm._v(" "), _c('span', {
    staticClass: "goods-num"
  }, [_vm._v(_vm._s(_vm.cartNums))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "nav-hover-box",
    on: {
      "mouseleave": _vm.mouseOut
    }
  }, [(_vm.isShow && _vm.currentNavId == 0) ? _c('categoryMenu', {
    attrs: {
      "catTree": _vm.catTree
    }
  }) : _vm._e(), _vm._v(" "), _c('navCommon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow && _vm.currentNavId == 1),
      expression: "isShow && currentNavId == 1"
    }],
    attrs: {
      "menuList": _vm.selfList,
      "currentNavIndex": 1
    }
  }), _vm._v(" "), (_vm.isShow && _vm.currentNavId == 2) ? _c('navCommon', {
    attrs: {
      "menuList": _vm.onlineList,
      "currentNavIndex": 2
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cc1005e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/mall-header.vue
// module id = 1612
// module chunks = 1